import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Modal,
  Form,
  Spin,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import { afectacionesEnum } from 'views/Tramites/GPM/enums';
import { patchPadronesMap, postPadronesMap } from 'api/recaudacion/utils';
import RenderFieldsByConfig from 'views/Tramites/GPM/components/RenderFieldsByConfig';
import { useSelector } from 'react-redux';
import { RightOutlined } from '@ant-design/icons';

const endpointsByAfectacion = {
  [afectacionesEnum.ALTA]: postPadronesMap,
  [afectacionesEnum.MODIFICACION]: patchPadronesMap,
};

const afectacionesMap = {
  1: 'Alta',
  2: 'Modificación',
  3: 'Baja',
  4: 'Consulta',
};

const ModalAfectacionPadron = ({
  visible,
  label,
  padron,
  callback,
  onCancel,
  configuracionDePadron: config,
  hasPermissionSendWS,
}) => {
  const [form] = Form.useForm();
  const padrones = useSelector((s) => s.catalogs.padrones);
  const tipoDeAfectacion = config.tipo_de_afectacion?.id || config.tipo_de_afectacion;
  const tipoDePadron = config.padron?.id || config.padron;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue(padron);
  }, []);

  const onFinish = async (enviar) => {
    setLoading(true);
    const values = form.getFieldsValue();
    const args = [];
    if ([afectacionesEnum.BAJA, afectacionesEnum.MODIFICACION].includes(tipoDeAfectacion)) {
      // eslint-disable-next-line react/prop-types
      args.push(padron.id);
    }
    if ([afectacionesEnum.ALTA, afectacionesEnum.MODIFICACION].includes(tipoDeAfectacion)) {
      args.push(values);
    }
    const saved = await endpointsByAfectacion[tipoDeAfectacion][tipoDePadron](...args);
    if (saved) {
      callback(saved, enviar);
      form.resetFields();
    }
    setLoading(false);
  };

  return (
    <Modal
      footer={null}
      closable={false}
      visible={visible}
      width="80%"
      title={(
        <FormSubmitControls
          label={label || config.descripcion
            || `${afectacionesMap[tipoDeAfectacion]} ${padrones.find((p) => p.id === tipoDePadron)?.descripcion}`}
          onFinish={() => onFinish(false)}
          onCancel={onCancel}
          loading={loading}
          onFinishText="Guardar sin enviar"
          customAction={() => onFinish(true)}
          customActionText="Guardar y enviar"
          allowCustomAction={hasPermissionSendWS}
          customActionIcon={<RightOutlined />}
        />
      )}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          name="afectacion_padron"
          onFinish={() => onFinish()}
        >
          <Row>
            <RenderFieldsByConfig
              fields={config.configuraciones_de_campos_de_padrones}
              tipoDeAfectacion={tipoDeAfectacion}
              setLoading={setLoading}
              tipoDePadron={tipoDePadron}
              padron={padron}
              // disabled
            />
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

ModalAfectacionPadron.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  configuracionDePadron: PropTypes.shape({
    configuraciones_de_campos_de_padrones: PropTypes.arrayOf(PropTypes.shape({})),
    tipo_de_afectacion: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape({ id: PropTypes.number.isRequired }),
    ]).isRequired,
    padron: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape(),
    ]).isRequired,
    descripcion: PropTypes.string.isRequired,
  }).isRequired,
  padron: PropTypes.shape({}),
  label: PropTypes.string,
  hasPermissionSendWS: PropTypes.bool,
};

ModalAfectacionPadron.defaultProps = {
  visible: false,
  padron: null,
  label: null,
  hasPermissionSendWS: false,
};

export default ModalAfectacionPadron;
